import type { AxiosPromise } from "axios";

export interface ApiResponse<T> {
	data: T;
}

export type AxiosApiResponsePromise<T> = AxiosPromise<ApiResponse<T>>;

export enum ApiResponseErrorType {
	VALIDATION = 'VALIDATION',
	BUSINESS_LOGIC = 'BUSINESS_LOGIC',
	AXIOS = 'AXIOS',
	UNKNOWN = 'UNKNOWN'
}

export type ValidationErrorDetail = {
	rule: string;
	message: string;
};

export type ValidationErrors = {
	[key: string]: ValidationErrorDetail[];
};

export type ErrorResponse = {
	errors: ValidationErrors;
};

export type BusinessLogicErrorResponse = {
	message: string;
	reason: string;
	[key: string]: unknown;
};

export type ValidationErrorType = {
	type: ApiResponseErrorType.VALIDATION;
	code: number;
	messages: ValidationErrors;
};

export type BusinessLogicErrorType = {
	type: ApiResponseErrorType.BUSINESS_LOGIC;
	code: number;
	reason: string;
	data: BusinessLogicErrorResponse;
};

export type AxiosErrorType = {
	type: ApiResponseErrorType.AXIOS;
	code: number;
	message: string;
};

export type UnknownErrorType = {
	type: ApiResponseErrorType.UNKNOWN;
	message: string;
};

export type ErrorResult = ValidationErrorType | BusinessLogicErrorType | AxiosErrorType | UnknownErrorType;